<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>从业人员增值税</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">从业人员增值税</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="4">
                <el-form-item label="年份">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.year"
                      placeholder="选择年份"
                      style="margin-right: auto"
                    >
                      <el-option label="2025年" value="2025"></el-option>
                      <el-option label="2026年" value="2026"></el-option>
                      <el-option label="2027年" value="2027"></el-option>
                      <el-option label="2028年" value="2028"></el-option>
                      <el-option label="2029年" value="2029"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="月份">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.mounth"
                      placeholder="选择月份"
                      style="margin-right: auto"
                    >
                      <el-option label="1月" value="1"></el-option>
                      <el-option label="2月" value="2"></el-option>
                      <el-option label="3月" value="3"></el-option>
                      <el-option label="4月" value="4"></el-option>
                      <el-option label="5月" value="5"></el-option>
                      <el-option label="6月" value="6"></el-option>
                      <el-option label="7月" value="7"></el-option>
                      <el-option label="8月" value="8"></el-option>
                      <el-option label="9月" value="9"></el-option>
                      <el-option label="10月" value="10"></el-option>
                      <el-option label="11月" value="11"></el-option>
                      <el-option label="12月" value="12"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="待申报" value="0"></el-option>
                    <el-option label="已申报" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="InvoicingAll()" class="btn"
            >批量申报</el-button
          >
          <el-button type="primary" @click="dowon()" class="btn"
            >税务申报模板下载</el-button
          >
          <el-button type="primary" @click="exportList(2)" class="btn"
            >导出申报excel</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="cardName"
            label="姓名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="monthAt" label="月份" align="center">
          </el-table-column>
          <el-table-column
            prop="cardTypeName"
            label="证件类型"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="cardCode"
            label="证件号码"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="nationCode"
            label="地区或国家"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="用户名称"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="linkPhone"
            label="联系电话"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="incomeSourceFromPlatformName"
            label="收入来源的互联网平台名称"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="targetName"
            label="收入来源的用户名称"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="targetId"
            label="收入来源的用户唯一标识码"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="changeName"
            label="增值税计税依据"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="vatTaxableItem"
            label="增值税征收品目"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop=""
            label="增值税征收率"
            align="center"
            width="100"
          >
            <template>0</template>
          </el-table-column>
          <el-table-column
            prop="vatCurrentPayable"
            label="增值税本期应纳税额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="vatReductionCode"
            label="增值税免减性质代码"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="vatReductionAmount"
            label="增值税免减税额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="vatSupplementRefundAmount"
            label="增值税应补(退)税额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="urbanTaxRate"
            label="城建适用税(费)率"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="urbanCurrentPayable"
            label="城建本期应纳税(费)率"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="urbanReductionCode"
            label="城建减免性质代码"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="urbanReductionAmount"
            label="城建减免税(费)额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="urbanSupplementRefundAmount"
            label="城建应补(退)税(费)额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="educationTaxRate"
            label="教育适用税(费)率"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="educationCurrentPayable"
            label="教育本期应纳税(费)率"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="educationReductionCode"
            label="教育减免性质代码"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="educationReductionAmount"
            label="教育减免税(费)额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="educationSupplementRefundAmount"
            label="教育应补(退)税(费)额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="localEducationTaxRate"
            label="地方适用税(费)率"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="localEducationCurrentPayable"
            label="地方本期应纳税(费)率"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="localEducationReductionCode"
            label="地方减免性质代码"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="localEducationReductionAmount"
            label="地方减免税(费)额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="localEducationSupplementRefundAmount"
            label="地方应补(退)税(费)额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.isDeclare == 0">{{
                scope.row.isDeclareName
              }}</span>
              <span class="greenColor" v-if="scope.row.isDeclare == 1">{{
                scope.row.isDeclareName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="changesAt"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround" v-if="scope.row.isDeclare == 0">
                <div class="operateBtn" @click="Invoicing(scope.row)">
                  提交申报
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose1"
    >
      <div style="height: 350px; overflow-y: scroll">
        <div v-for="(item, index) in errorList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taxData(),
      ruleForm: {
        name: "",
        status: "",
        phone: "",
        mounth: "",
        year: "2025",
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible1: false,
      selectData: {},
      status: "",
      type: "0", //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    dowon() {
      window.open(
        "http://down.baoanlailou.com/file/excel/template-从业人员-增值税.xlsx"
      );
    },
    goDetail(val) {
      if (val.memberType == 1) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: val.memberId,
          },
        });
      } else {
        this.$router.push({
          path: "/askariDetail",
          query: {
            id: val.memberId,
          },
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.status = "";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList() {
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        isDeclare: this.ruleForm.status,
        year: this.ruleForm.year,
        month: this.ruleForm.mounth,
        name: this.ruleForm.name,
        ids: arr,
      };
      this.$axios
        .post("/admapi/tax/bodyguard/valueaddedtax/export", param, {
          responseType: "blob",
        })
        .then((data) => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      this.$confirm("是否批量提交申报现", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.multipleTable.length == 0) {
            this.$message({
              message: "请选择确认数据",
              type: "warning",
            });
            return;
          }
          let arr = [];
          for (var i = 0; i < this.multipleTable.length; i++) {
            arr.push(this.multipleTable[i].billDetailNo);
          }
          let param = {
            billDetailNoList: arr,
            state: this.status,
            failDesc: this.failDesc,
          };
          this.$axios
            .post(`/admapi/tax/bodyguard/valueaddedtax/batchsubmit`, param)
            .then(({ data }) => {
              this.$message({
                message: "批量申报成功",
                type: "success",
              });
              this.multipleTable = [];
              this.$refs.multipleTable.clearSelection();
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    Invoicing(val) {
      this.selectData = val;
      this.$confirm("是否确认提交申报", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            billDetailNo: this.selectData.billDetailNo,
            state: this.status,
            failDesc: this.failDesc,
          };
          this.$axios
            .post(`/admapi/tax/bodyguard/valueaddedtax/submit`, param)
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.phone = "";
      this.ruleForm.id = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        isDeclare: this.ruleForm.status,
        year: this.ruleForm.year,
        month: this.ruleForm.mounth,
        name: this.ruleForm.name,
      };
      this.$axios
        .post(`/admapi/tax/bodyguard/valueaddedtax/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
